module.exports = require("core-js/library/fn/symbol/to-primitive");


// WEBPACK FOOTER //
// ../node_modules/@babel/runtime-corejs2/core-js/symbol/to-primitive.js